import { useAnalytics, useMetrics, useReports } from "@sail/observability";
import { useMemo } from "react";
export default function useObservabilityFns() {
    const analytics = useAnalytics();
    const metrics = useMetrics();
    const reports = useReports();
    const observabilityFns = useMemo(()=>{
        return {
            analytics,
            metrics,
            errors: reports
        };
    }, [
        analytics,
        metrics,
        reports
    ]);
    return observabilityFns;
}

//# sourceMappingURL=useObservabilityFns.js.map